var _defs, _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.2 2.4 57.6 57.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: "40%",
    cy: "32%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3fd6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a8ea0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3 C44.5 3 51 11.5 51 21 C51 28.5 46.5 33.5 42.5 38.5 C41 40.5 40.3 42.5 40.3 45 L23.7 45 C23.7 42.5 23 40.5 21.5 38.5 C17.5 33.5 13 28.5 13 21 C13 11.5 19.5 3 32 3Z",
    fill: "url(#k)",
    stroke: "#067080",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14 Q25 7 32 7",
    stroke: "#fff",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 16,
    height: 11,
    rx: 2,
    fill: "#9a9a9a",
    stroke: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.7 L40 48.7 M24 52.3 L40 52.3",
    stroke: "#555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56 L36 56 L34 60 L30 60Z",
    fill: "#555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.d78c1ffe4799b54505a1215089559d5f.svg";
export { ForwardRef as ReactComponent };